import { fetchWithHandledResponse, generatePostHeaders } from '../helpers';

import { apiUrl } from 'config';

export const fetchDocument = documentId => {
    return fetchWithHandledResponse(`${apiUrl}/document/${documentId}`);
};

export const saveDocument = ({ id: documentId, ...document }) => {
    return fetchWithHandledResponse(`${apiUrl}/document/${documentId}`, {
        method: 'PATCH',
        headers: generatePostHeaders(document),
        body: JSON.stringify(document),
    });
};

export const deleteDocument = documentId => {
    return fetchWithHandledResponse(`${apiUrl}/document/${documentId}`, {
        method: 'delete',
    });
};

export const createDocumentAnalysis = (documentId, analysisPriority) => {
    let requestUrl = `${apiUrl}/analysis/document/${documentId}`;
    if (analysisPriority) {
        requestUrl += `?analysisPriority=${analysisPriority}`;
    }

    return fetchWithHandledResponse(requestUrl, {
        method: 'post',
        headers: generatePostHeaders(null),
        body: null,
    });
};

export const setDocumentMonitoringStatus = (documentId, isMonitored) => {
    return fetchWithHandledResponse(
        `${apiUrl}/document/${documentId}/monitor/${isMonitored.toString()}`,
        {
            method: 'post',
            headers: generatePostHeaders(null),
            body: null,
        }
    );
};
